import React from 'react';
import PropTypes from 'prop-types';
import CalendarStarIcon from 'mdi-react/CalendarStarIcon';
import CalendarSyncIcon from 'mdi-react/CalendarSyncIcon';
import AccountGroupOutlineIcon from 'mdi-react/AccountGroupOutlineIcon';
import AccountMultiplePlusOutlineIcon from 'mdi-react/AccountMultiplePlusOutlineIcon';
import FormatListChecksIcon from 'mdi-react/FormatListChecksIcon';
import BellRingOutlineIcon from 'mdi-react/BellRingOutlineIcon';
import CellphoneIcon from 'mdi-react/CellphoneIcon';
import FileExportIcon from 'mdi-react/FileExportIcon';
import CheckboxMarkedCircleOutlineIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon';
import MessageTextOutlineIcon from 'mdi-react/MessageTextOutlineIcon';
import ChartBarIcon from 'mdi-react/ChartBarIcon';
import { partial } from '../../../util/translation/translation';
import FeatureShowcase from '../../../shared/components/custom/FeatureShowcase';

/**
 * Events in two steps: set one up (or a series that repeats): who it's
 * for, places, guests and the waitlist, questions and ready-made reminders.
 * Then people sign up in the app and the club follows the participants.
 */
const EventsShowcase = ({ collapsible, action }) => {
  const s = partial('shared');
  return (
    <FeatureShowcase
      storageKey="eventsShowcaseHidden"
      icon={CalendarStarIcon}
      title={s('eventsInfoTitle')}
      subtitle={s('eventsShowcaseSubtitle')}
      showLabel={s('eventsShowcaseShow')}
      uses={[
        {
          key: 'setup',
          step: s('showcaseStep', { step: 1 }),
          icon: CalendarStarIcon,
          label: s('eventsSetupLabel'),
          text: s('eventsSetupText'),
          cards: [
            {
              key: 'audience',
              icon: AccountGroupOutlineIcon,
              title: s('eventsCardAudience'),
              text: s('eventsCardAudienceText'),
            },
            {
              key: 'places',
              icon: AccountMultiplePlusOutlineIcon,
              title: s('eventsCardPlaces'),
              text: s('eventsCardPlacesText'),
            },
            {
              key: 'questions',
              icon: FormatListChecksIcon,
              title: s('eventsCardQuestions'),
              text: s('eventsCardQuestionsText'),
            },
            {
              key: 'reminders',
              icon: BellRingOutlineIcon,
              title: s('eventsCardReminders'),
              text: s('eventsCardRemindersText'),
            },
            {
              key: 'series',
              icon: CalendarSyncIcon,
              title: s('eventsCardSeries'),
              text: s('eventsCardSeriesText'),
            },
          ],
        },
        {
          key: 'signup',
          step: s('showcaseStep', { step: 2 }),
          icon: CellphoneIcon,
          label: s('eventsSignupLabel'),
          text: s('eventsSignupText'),
          items: [
            {
              key: 'export',
              icon: FileExportIcon,
              label: s('eventsItemExport'),
            },
            {
              key: 'attended',
              icon: CheckboxMarkedCircleOutlineIcon,
              label: s('eventsItemAttended'),
            },
            {
              key: 'waitlist',
              icon: AccountMultiplePlusOutlineIcon,
              label: s('eventsItemWaitlist'),
            },
            {
              key: 'message',
              icon: MessageTextOutlineIcon,
              label: s('eventsItemMessage'),
            },
            { key: 'stats', icon: ChartBarIcon, label: s('eventsItemStats') },
          ],
        },
      ]}
      collapsible={collapsible}
      action={action}
    />
  );
};

EventsShowcase.propTypes = {
  collapsible: PropTypes.bool,
  action: PropTypes.node,
};

EventsShowcase.defaultProps = {
  collapsible: true,
  action: null,
};

export default EventsShowcase;
